import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 5.46683C2 4.72009 2 4.34672 2.14532 4.06151C2.27316 3.81063 2.47713 3.60665 2.72801 3.47882C3.01323 3.3335 3.3866 3.3335 4.13333 3.3335H6.44968C6.7758 3.3335 6.93886 3.3335 7.09231 3.37034C7.22836 3.403 7.35842 3.45687 7.47771 3.52998C7.61227 3.61243 7.72757 3.72773 7.95817 3.95834L8.04183 4.04199C8.27243 4.27259 8.38773 4.38789 8.52229 4.47035C8.64158 4.54345 8.77164 4.59733 8.90769 4.62999C9.06114 4.66683 9.2242 4.66683 9.55032 4.66683H11.8667C12.6134 4.66683 12.9868 4.66683 13.272 4.81215C13.5229 4.93999 13.7268 5.14396 13.8547 5.39484C14 5.68006 14 6.05343 14 6.80016V10.5335C14 11.2802 14 11.6536 13.8547 11.9388C13.7268 12.1897 13.5229 12.3937 13.272 12.5215C12.9868 12.6668 12.6134 12.6668 11.8667 12.6668H4.13333C3.3866 12.6668 3.01323 12.6668 2.72801 12.5215C2.47713 12.3937 2.27316 12.1897 2.14532 11.9388C2 11.6536 2 11.2802 2 10.5335V5.46683Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFolderClose;
